import React from "react";
import { useNavigate } from "react-router-dom";

const LVL = { normal: "badge-normal", moderate: "badge-watch", severe: "badge-critical" };
const TREND = { improving: { g: "▲", c: "up" }, stable: { g: "▬", c: "flat" }, worsening: { g: "▼", c: "down" } };

const Row = ({ label, value }) => (
  <div className="sd-row"><span className="sd-lab">{label}</span><span className="sd-val">{value}</span></div>
);

const SchoolDetailModal = ({ school, weather, onClose }) => {
  const navigate = useNavigate();
  if (!school) return null;
  const t = TREND[school.trend] || TREND.stable;
  return (
    <div className="modal-overlay" data-testid="school-detail-modal" onClick={onClose}>
      <div className="modal replay-panel sd-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div className="modal-title"><i className="fa-solid fa-school" /> {school.name}</div>
          <button className="modal-close" onClick={onClose} data-testid="school-detail-close"><i className="fa-solid fa-xmark" /></button>
        </div>
        <div className="sd-body">
          <div className="sd-badges">
            <span className={`badge ${LVL[school.level]}`}>{school.level.toUpperCase()}</span>
            <span className={`trend-ind ${t.c}`}><span className="trend-glyph">{t.g}</span> {school.trend}</span>
            <span className="badge badge-info">+{school.added_delay_min} min</span>
          </div>
          <Row label="Location" value={school.corridor + " area"} />
          <Row label="Est. student population" value={school.students ? `${school.students.toLocaleString()} students` : "—"} />
          <Row label="Morning peak" value={school.morning_peak} />
          <Row label="Afternoon peak" value={school.afternoon_peak} />
          <Row label="Current congestion" value={`${Math.round(school.congestion_index * 100)}% (${school.corridor_status})`} />
          <Row label="Nearest corridor" value={school.corridor} />
          <Row label="Added corridor delay" value={`+${school.added_delay_min} min`} />
          <Row label="Weather influence" value={(weather?.risk_level || "low") + " risk · " + (weather?.condition || "—")} />
          <div className="sd-rec"><i className="fa-solid fa-lightbulb" /> {school.level === "normal"
            ? "No school-driven congestion expected around this school in the next hour."
            : `Expect elevated demand near ${school.corridor} around dismissal. Consider a traffic officer at the nearest junction.`}</div>
          <button className="btn btn-primary sd-openmap" data-testid="open-in-ops-map"
            onClick={() => navigate(`/ops?focus=${school.lat},${school.lng}&label=${encodeURIComponent(school.name)}`)}>
            <i className="fa-solid fa-map-location-dot" /> Open in Operations Map
          </button>
        </div>
      </div>
    </div>
  );
};

export default SchoolDetailModal;
